<template>
  <div :class="sidebarClasses"
       :data-background-color="backgroundColor"
       :data-active-color="activeColor" :style="{top: offsetTop}">
    <a href="/" class="sidebar-logo-container">
      <logo></logo>
    </a>
    <ui-scrollbar>
    <div class="sidebar-wrapper">
      <slot></slot>
      <ul :class="navClasses" class="noHideSidebar">
        <slot name="links">
          <sidebar-item
                        v-for="(link, index) in sidebarLinksVisible"
                        :key="link.name + index"
                        :link="link"
                        :isLink="link.isLink"
                        :link-access="getLinkAccess(link.name)"
                        >
            <sidebar-item v-for="(subLink, index) in link.children"
                          :key="subLink.name + index"
                          :link="subLink"
                          :link-access="getLinkAccess(subLink.name)">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
    </ui-scrollbar>
  </div>
</template>
<script>
  import logo from 'src/components/Logo/Logo.vue'
  import config from '@/config'
  import {HIDE_SIDEBAR_LINKS} from '@/constants';

  export default {
    components: {
      logo
    },
    props: {
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'black',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'success',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/logo@2x.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    data () {
      return {
        minimized: false,
        linksMap: {},
        offsetTop: '0px',
        sidebarLinksVisible: this.sidebarLinks,
        hiddenPages: config(HIDE_SIDEBAR_LINKS) && config(HIDE_SIDEBAR_LINKS).split(',')
      }
    },
    computed: {
      respNum () {
        return this.$store.getters['resp/blankRespNum']
      },
      notificationsCount () {
        let notificationsCount = 0;

        this.sidebarLinksVisible.forEach((item) => {
          if (item.path === '/resp/list' && this.respNum) {
            notificationsCount += this.respNum;
          }
        })

        if (this.$store.state.user && this.$store.state.user.user && this.$store.state.user.user.data && this.$store.state.user.user.data.msgr && !this.$store.state.user.user.data.msgr.mgs.length) {
          notificationsCount += 1;
        }

        return notificationsCount
      },
      sidebarClasses () {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses () {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      initSendNotificationCount () {
        if (window.top[0]) {
          setInterval(() => {
            window.parent.postMessage(`notifications_${this.notificationsCount}`, '*')
          }, 5000)
        }
      },
      getLinkAccess (name) {
        if (!name || typeof name !== 'string') return

        let accesses = ''
        function findLinkAccess (links) {
          links.forEach((link) => {
            if (link.name === name && link.access) {
              accesses = link.access
            }
            if (link.children && link.children.length) {
              findLinkAccess(link.children)
            }
          })
        }
        findLinkAccess(this.sidebarLinks)
        return accesses
      },
      removeHiddenPagesFromSidebar () {
        if (!this.hiddenPages || !this.hiddenPages.length) {
          return;
        }

        this.hiddenPages.forEach(hiddenPageName => {
          this.sidebarLinks.forEach((sidebarItem, sidebarItemIndex) => {
            if (hiddenPageName.length > 0) {
              if (sidebarItem.children) {
                sidebarItem.children.forEach((sidebarItemChildren, sidebarItemChildrenIndex) => {
                  this.hidePageFromSidebar(sidebarItemChildren, hiddenPageName, sidebarItemChildrenIndex, sidebarItemIndex, 'children');
                })
              }

              this.hidePageFromSidebar(sidebarItem, hiddenPageName, sidebarItemIndex);
            }
          })
        })
      },
      hidePageFromSidebar (link, linkName, linkIndex, linkParentIndex, linkParentChildrensPropertyName) {
        if (link.path.indexOf(linkName) >= 0 && this.hiddenPages.includes(linkName)) {
          if (linkParentIndex) {
            return this.sidebarLinksVisible[linkParentIndex][linkParentChildrensPropertyName].splice(linkIndex, 1)
          }

          this.sidebarLinksVisible.splice(linkIndex, 1)
        }
      }
    },
    mounted () {
      this.removeHiddenPagesFromSidebar();
      this.initSendNotificationCount();
    },
    beforeDestroy () {
      this.$store.commit('sidebarOpened', false)
    }
  }

</script>
<style lang="scss">
  @import '../../assets/sass/grid';
  @import 'src/assets/sass/paper/variables';

 .navbar-header-logo{display: none;}
.sidebar {
  background-color: #F9FAFC;
  position: absolute;
  top: 0;
  display: flex;
  flex-direction: column;
  z-index: 20;
  bottom: 0;
  min-height: auto;
  height: 100%;
  max-height: initial;
  overflow: visible;
  border-right: 1px solid #E4E7ED;
  opacity: 1;
  .isHidden {
    display: none !important;
  }
  .__vuescroll .__rail-is-vertical {
    z-index: 5;
  }
  .sidebar-logo-container {
    overflow: hidden;
  }
  .user {
    min-height: $topbat-height;
    padding-top: 12px;
    margin-top: 0;
    @media (max-width: 480px), (orientation: landscape) and (max-width: 1023px) {
      min-height: 60px;
    }
  }
  .nav>li {
    overflow: hidden;
  }
  @media (min-width: $width-xl) {
    left: calc((100vw - #{$width-xl}) / 2);
  }
  @media (max-width: $width-md) {
    .sidebar-wrapper {
      min-height: 100vh;
      padding-bottom: 60px;
    }
  }
  @media (min-width: $width-md) {
    transition: all .4s ease;
    &::before {
      content: '';
      top: 0;
      right: calc(100% + 1px);
      display: block;
      position: absolute;
      background: #fff;
      border-bottom: 1px solid #E4E7ED;
      height: $topbat-height;
      width: calc((100vw - #{$width-xl}) / 2);
      left: auto;
      transition: all .4s ease;
    }
  }

  &.is-fixed{
    position: fixed;
  }
  &-wrapper{width: 100% !important;border-right:none !important;}

  &-logo-container{height: $topbat-height !important;}
  &-normal{font-size: 14px;}
}
.wrapper{height: auto;}
.navbar-header{transition: all .4s ease;}
.navbar-header .navbar-toggle{transition: all .4s ease;}
.nav-mobile-menu{display: none;}


@media screen and (max-width:$width-md){
  .nav-mobile-menu{display: block;}
}
@media screen and (max-width:1920px){
  .navbar-search{margin-left: 0;}
  .sidebar-logo-container{border-right: none !important;}
  .main-panel > .content{max-width: 100%;}
}

@media screen and (max-width:1440px) {
  .main-panel{padding-left: 280px;}
}
@media screen and (max-width:1400px){
  .main-panel{padding-left: 260px;}
  body.sidebar-is-minimize{
    .main-panel{padding-left: 85px;}
  }
}

@media (max-width:1024px){
  .header-wrapper{position: relative;}
}

@media screen and (max-width:768px) {
  .preheader{height: auto;min-height: 40px;}
  .main-panel{padding-left: 0;}
  .navbar-header-logo{
    display: block;
    height: auto;
    margin-left: 20px;
  }
  .navbar-header{padding-left: 0;}
  .navbar-header .navbar-toggle{margin-left: auto;}
}

@media screen and (max-width:991px) {
  body,html{overflow-x: hidden;}
  body.sidebar-is-minimize .navbar-header{padding-left: 0;}
  .navbar-header-logo{display: block;height: initial;}
  .navbar-header .navbar-toggle{margin-left: 30px;}
  body.sidebar-is-minimize{
    .main-panel{
      left: 0;
      width: 100%;
      & > .content{max-width: 100%;}
    }
    .navbar-header{margin-right: 0;left: 0;}
    .sidebar{
      right: -80px;
      width: 300px;
      .nav li > a{min-width: 260px;padding-left: 30px;}
      // .nav [data-toggle="collapse"] ~ div > ul > li > a,
      // .off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle="collapse"] ~ div > ul > li > a {
      //   opacity: 0;
      // }
      .logo h1{opacity: 1;}
      .nav{
        .nav-icon + *{opacity:1;}
        .sidebar-normal{opacity:1 !important;}
        .sidebar-mini{opacity: 0 !important;}
      }
    }
  }

}

@media (max-width:480px) {
  .navbar-header .navbar-toggle{
    margin-left: auto;
  }
  .navbar-header .langs-select.el-dropdown {
    display: none;
  }
}

body.sidebar-is-hover{
  .sidebar{
      width: 260px !important;
      .nav li > a{min-width: 260px;padding-left: 30px;}
      .logo h1{opacity: 1 !important;}
      .nav{
        .nav-icon + *{opacity:1 !important;}
        .sidebar-normal{opacity:1 !important;}
        .sidebar-mini{opacity: 0 !important;}
      }
    }
  .main-panel{padding-left: 85px !important;}
}

</style>